import { Fixtuur } from '@fixtuur/backpack';
import { useDispatch, useSelector } from '../../../../store/redux';
import * as Selectors from '../../../../store/selectors';
import { useAsyncThrowError } from '../../../useAsync';
import { getConfiguration } from '../../../shared/getConfiguration';
import { resolveFurnitureChoiceTree } from './furniture';
import { useCurrentSelections } from '../../../useAr/useAr/useCurrentSelections';
import { useMemo } from 'preact/hooks';

export function useFurnitureChoices() {
    const dispatch = useDispatch();
    const serviceConfig = useSelector(Selectors.Core.serviceConfig);

    const currentConfiguration = useCurrentConfiguration();

    const particles = useMemo(
        () => currentConfiguration && Fixtuur.Configuration.apiParticles(currentConfiguration),
        [currentConfiguration],
    );

    const furnitureChoices = useAsyncThrowError(async () => {
        if (serviceConfig && particles) {
            return resolveFurnitureChoiceTree(particles, serviceConfig, dispatch);
        } else return undefined;
    }, [particles, serviceConfig]).result;

    return {
        furnitureChoices,
        isFurnitureChoicesLoading: furnitureChoices === undefined,
    };
}
export function useCurrentConfiguration() {
    const serviceConfig = useSelector(Selectors.Core.serviceConfig);
    const currentConfigurator = useSelector(Selectors.Initialisation.currentConfiguratorDefinition);
    const selections = useCurrentSelections();
    const dispatch = useDispatch();
    const currentConfiguration = useAsyncThrowError(
        async () =>
            serviceConfig && currentConfigurator && selections
                ? await getConfiguration(
                      serviceConfig,
                      currentConfigurator?.configurationSpaceId,
                      selections,
                      dispatch,
                  )
                : undefined,
        [currentConfigurator, serviceConfig, selections],
    ).result;

    return currentConfiguration ?? null;
}
